import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod/v3'

const tasksDetailSearchSchema = z.object({
  category: z.string(),
  id: z.string(),
  source: z.enum(['finding']).optional(),
})

/**
 * Legacy URL shape (`/tasks/detail?category=…&id=…`) — kept only as a
 * redirect so emailed/Slack deep links keep resolving. The canonical route
 * is `/tasks/$taskId?category=…`.
 */
export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/tasks_/detail',
)({
  validateSearch: tasksDetailSearchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/tasks/$taskId',
      params: { workspaceId: params.workspaceId, taskId: search.id },
      search: { category: search.category, source: search.source },
      replace: true,
    })
  },
})
